import gql from 'graphql-tag';

export const RENTAL_ITEMS_BOOKING = gql`
  query rentalItemsBookings(
    $rentalItemsBookingId: Int
    $businessOwnerId: Int
    $token: String
  ) {
    rentalItemsBookings(
      rentalItemsBookingId: $rentalItemsBookingId
      businessOwnerId: $businessOwnerId
      token: $token
    ) {
      id
      isCanceled
      referenceNumber
      guestFirstName
      guestLastName
      guestPhoneNumber
      guestEmail
      platform
      fromDate
      toDate
      startTime
      endTime
      
      payments {
        id
        paymentType
        currency {
          currency
        }
        totalPrice
      }
      
      bookedAddOns {
        id
        addOnCount
        totalPrice
        currency {
          currency
        }
        addOn {
          id
          title
          titleNo
          description
          descriptionNo
          prices {
            participant {
              participant
            }
            currency {
              currency
            }
            value
          }
        }
      }
      units {
        unitsNumber
        totalPrice
        bookingPrices
      }
    }
  }
`;



export const RENTAL_ITEMS_BOOKING_UPDATE = gql`
  query rentalItemsBookings(
    $rentalItemsBookingId: Int
    $businessOwnerId: Int
    $token: String
  ) {
    rentalItemsBookings(
      rentalItemsBookingId: $rentalItemsBookingId
      businessOwnerId: $businessOwnerId
      token: $token
    ) {
      id
      isCanceled
      referenceNumber
      guestFirstName
      guestLastName
      guestPhoneNumber
      guestEmail
      platform
      fromDate
      toDate
      startTime
      endTime
      rentalItems {
        id
        title
        photo
        productCode
        availableUnits
        description
        descriptionNo
        pricesType
        
        prices {
          id
          currency {
            currency
          }
          value
          day {
            id
            name
          }
          type
        }
        
        hourlyPrices {
          id
          currency {
            currency
          }
          value
          hour {
            id
            hour
            displayHour
          }
        }
        
        addOns {
          id
          title
          titleNo
          description
          descriptionNo
          photo
          prices {
            currency {
              currency
            }
            value
          }
        }
      }
      
      payments {
        id
        paymentType
        currency {
          currency
        }
        totalPrice
      }
      
      bookedAddOns {
        id
        addOnCount
        totalPrice
        currency {
          currency
        }
        addOn {
          id
          title
          titleNo
          description
          descriptionNo
          prices {
            participant {
              participant
            }
            currency {
              currency
            }
            value
          }
        }
      }
      units {
        unitsNumber
        totalPrice
        bookingPrices
      }
    }
  }
`;